export default __webpack_public_path__ + "static/media/img2.b34a3ef3.png";